module.exports =
	slug: ""
	path: "page/page"
	name: "top"
	children: [
		{
			slug: "about/:projectName"
			path: "page/page"
			name: "about"
		}
		{
			slug: "posts/:projectName/:category/:page"
			path: "archive/archive"
			name: "posts"
		}
		{
			slug: "posts/:projectName/:id"
			path: "single/single"
			name: "post"
		}
		{
			slug: "publications/:page"
			path: "archive/archive"
			name: "publications"
		}
		{
			slug: "publications/:page/:id"
			path: "single/single"
			name: "publication"
		}
		{
			slug: "news/:page"
			path: "archive/archive"
			name: "news"
		}
		{
			slug: "en"
			path: "page/page"
			name: "en_top"
			children: [
				{
					slug: "projects/:projectName"
					path: "page/page"
					name: "en_about"
				}
				{
					slug: "archive/:projectName/:category/:page"
					path: "archive/archive"
					name: "en_posts"
				}
				{
					slug: "projects/:projectName/:id"
					path: "single/single"
					name: "en_post"
				}
				{
					slug: "publications/:page"
					path: "archive/archive"
					name: "en_publications"
				}
				{
					slug: "publications/:page/:id"
					path: "single/single"
					name: "en_publication"
				}
				{
					slug: "news/:page"
					path: "archive/archive"
					name: "en_news"
				}
			]
		}
	]


// WEBPACK FOOTER //
// ./src/config/architecture.coffee